import React from 'react';
import { Step } from '../components/Stepper';

class StepClass {
  constructor(url, title) {
    this.url = url;
    this.title = title;
  }
  getStep = (i, url = null) => <Step title={this.title} url={url ? url : this.url} key={i} />;

  getUrl = () => this.url;
}

export default StepClass;



// WEBPACK FOOTER //
// src/classes/StepClass.js